/* Pocket Factory · hero composer (beta). Contract, events and hooks: snippets/pocket-composer.liquid. */
(function(root,factory){
  const api=factory();
  if(typeof module==='object'&&module.exports)module.exports=api;
  else{root.PocketComposer=api;api.init(root.document);}
})(typeof window!=='undefined'?window:globalThis,function(){
  'use strict';
  // Photos, GIFs, HEIC and PDF too: the upload gets each ready in the browser (pocket-assets.js prepareFile).
  const TYPES={'image/png':'png','image/jpeg':'jpeg','image/webp':'webp','image/svg+xml':'svg','image/gif':'gif','image/heic':'heic','image/heif':'heic','application/pdf':'pdf'},EXT={png:'image/png',jpg:'image/jpeg',jpeg:'image/jpeg',webp:'image/webp',svg:'image/svg+xml',gif:'image/gif',heic:'image/heic',heif:'image/heif',pdf:'application/pdf'};
  const T={chip:'Website: %s, press Delete to remove',remove:'Remove %s',added:'Website added: %s',removed:'%s removed',replaced:'Replaced %s.',
    image:'Image: %s, press Delete to remove',art:'Image: %s, on your card, press Delete to remove',imageAdded:'Image added: %s',onCard:'On your card',nowOnCard:'%s is on your card',
    notes:['We’ll print “','” as your name.'],design:['We’ll use “','” for your design.'],helper:'',addSite:'Press Preview to put it on your card.',
    type:'Use a PNG, JPG, WebP, GIF, HEIC, SVG or PDF file.',size:'This file is over 50 MB. Export a smaller JPG, then add it.',max:'You can add up to 3 images.',broken:'We couldn’t open that image. Try another file.',
    needSite:'Add your website so we can find your logo and colors.',badLink:'Check that link, or type your business name instead.',
    // One box (data-pfc-mode="one_box"): their link, then the words for their design.
    describe:'Describe your design (optional)',describeShort:'Describe your design',describeTiny:'Your design',linkFirst:'Add your link first, then describe your design.',
    promptShort:'Describe your design in a few more words, or leave it empty.',linkAdded:'%s added: ',website:'Website',review:'%s review link',
    nameChip:'Business name: %s, press Delete to remove',selected:'%s selected. Press Backspace again to remove it.',left:'%s characters left'};
  const LINK='<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" focusable="false"><path d="M10 14a4.5 4.5 0 0 0 6.4 0l3-3a4.5 4.5 0 0 0-6.4-6.4l-1 1m1 5.4a4.5 4.5 0 0 0-6.4 0l-3 3a4.5 4.5 0 0 0 6.4 6.4l1-1" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
  const CROSS='<svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg>';
  const fmt=(text,value)=>text.replace('%s',value),clean=value=>value.trim().replace(/\s+/g,' ');
  // A comma typed for the dot ("joesplumbing,com") is a link to check too, never their name.
  const LINKISH=/:\/\/|\/|(?:^|[\s,])www\.|[\p{L}\p{N}-]\.(?:\p{L}{2,3}|page|link|info|site|shop|store|online)(?=$|[\s,?#:])|[\p{L}\p{N}-],(?:com|net|org|co|us|biz|info)(?=$|[\s?#:])/iu;
  // One word, or a word and a dot ("getpocketfac", "getpocketfactory.co"): maybe a website still being typed.
  const SITE_SO_FAR=/^[a-z0-9][a-z0-9-]*\.?[a-z]*$/;

  // Token -> {url,domain,tld,label,path} or null. Strict: a real TLD (pocket-tlds.js); loose (submit): any letters ending.
  function parseWebsite(raw,options={}){
    const win=options.window||globalThis,token=String(raw||'').trim().replace(/^[(<[{"'‘“]+/,'').replace(/[)>\]}"'’”.,;:!?]+$/,'');
    if(!token||token.length>2048||/[\s@\\]/.test(token)||(/^[a-z][a-z\d+.-]*:/i.test(token)&&!/^https?:\/\//i.test(token)))return null;
    const match=/^(?:https?:\/\/)?([^/?#]+)([/?#].*)?$/i.exec(token);if(!match)return null;
    const host=match[1].toLowerCase(),labels=host.split('.');
    if(labels.length<2||!labels.every(label=>/^[\p{L}\p{N}](?:[\p{L}\p{N}-]{0,61}[\p{L}\p{N}])?$/u.test(label)))return null;
    let url;try{url=win.PocketBrandService.normalizeWebsite(token);}catch(_){return null;}
    const domain=new win.URL(url).hostname,tld=domain.split('.').pop();
    if(options.loose?!/^(?:[a-z]{2,}|xn--[a-z\d-]+)$/.test(tld):!(options.tlds||win.PocketTlds)?.has(labels[labels.length-1]))return null;
    return {url,domain,tld,label:host.replace(/^www\./,''),path:(match[2]||'').replace(/#.*/,'').replace(/^\/$/,'')};
  }

  function init(doc){
    const host=doc.querySelector('[data-pfc]'),form=doc.querySelector('[data-rv-url-form]'),carrier=form?.querySelector('[data-rv-url]'),submit=form?.querySelector('button');
    if(!host||!carrier||!submit||host.dataset.pfcReady)return null;
    const win=doc.defaultView,q=s=>host.querySelector(s),entry=form.parentElement,status=doc.querySelector('[data-rv-url-status]');
    const node=(tag,className,text)=>{const n=doc.createElement(tag);if(className)n.className=className;if(text!=null)n.textContent=text;return n;};
    const asButton=(n,label,tab)=>{n.setAttribute('role','button');n.tabIndex=tab;n.setAttribute('aria-label',label);};
    const hint=q('[data-pfc-hint]'),nameButton=q('[data-pfc-name]'),useButton=q('[data-pfc-use]'),removeButton=q('[data-pfc-remove]'),file=q('[data-pfc-file]'),toastNode=q('[data-pfc-toast]');
    // "Anything specific?": the one box for their words (pocket-design.js reads them). Enter there is Preview too.
    const ideaBox=doc.querySelector('[data-pfc-idea]');
    // One box: one text box for their link and, once it is a chip, the words for their design (textarea, 17px: no iOS
    // zoom; no inputmode, so the keyboard has a space bar). The chips sit on their own line above it.
    const one=host.dataset.pfcMode==='one_box';
    const field=node('div','pfc-field'),input=node(one?'textarea':'input','pfc-input'),chipRow=one?node('div','pfc-chips'):field;
    const attrs={id:carrier.id+'Composer',type:'text',autocomplete:'url',autocapitalize:'none',autocorrect:'off',spellcheck:'false',enterkeyhint:'go',maxlength:'2048',placeholder:carrier.placeholder,'aria-describedby':[carrier.getAttribute('aria-describedby'),hint.id].filter(Boolean).join(' ')};
    if(one){delete attrs.type;attrs.rows='1';attrs.autocomplete='off';}
    for(const name in attrs)input.setAttribute(name,attrs[name]);
    if(one){chipRow.hidden=true;field.append(chipRow);}
    field.append(input);form.insertBefore(field,submit);
    const typed=carrier.value,typing=doc.activeElement===carrier,caret=carrier.selectionStart;
    carrier.value='';carrier.required=false;carrier.tabIndex=-1;carrier.classList.add('pfc-carrier');carrier.setAttribute('aria-hidden','true');carrier.setAttribute('autocomplete','off');
    // Focus or blur of #ReviewsWebsite by other code (failed lookup, "Change", buy-bar nudge) reaches the visible field.
    carrier.focus=options=>{adopt();input.focus(options);};carrier.blur=()=>input.blur();
    const label=doc.querySelector('label[for="'+carrier.id+'"]');if(label)label.htmlFor=input.id;
    form.classList.add('pfc-on');if(one)form.classList.add('pfc-one');
    new win.MutationObserver(()=>{const invalid=carrier.getAttribute('aria-invalid');if(invalid)input.setAttribute('aria-invalid',invalid);else input.removeAttribute('aria-invalid');}).observe(carrier,{attributes:true,attributeFilter:['aria-invalid']});

    let site=null,siteChip=null,images=[],art=null,selected=null,error='',pasting=false,asName=false,chosen='',lastKey='',lastAt=0,toastTimer=0,undo=null,searchTimer=0,search=null,seq=0,held=false,holdTimer=0,sentArt=null,sentSite='';
    // One box: the business name a link came with (a share text's first line, or words typed before the link), the chip
    // Backspace picked, and words that were their description before the link chip went (they stay a description).
    let nameText='',nameChip=null,picked=null,promptMark='';
    // A name they chose with "Use ‘Dr.Tattoo’ as my business name" (or their card's own name, put back by question 1's
    // "Change") stays their name: that word is never chipped as a website (commit), and Preview never looks it up.
    const named=()=>asName||!!chosen&&clean(input.value)===chosen;
    const say=text=>{q('[data-pfc-live]').textContent=text;};
    // Through the analytics allow-list, like every other storefront event.
    const track=(name,properties)=>{try{win.PocketAnalytics?.capture?.(name,{flow:'reviews-v2',...properties});}catch(_){}};
    const fail=text=>{error=text;say(text);sync();};
    // "://", a "/" path, www. or a web address ending (.com, .co, .ee, .page…) is a link, never their business name
    // (nor a name printed next to a website). A name like "Dr.Tattoo" picked from the row stays theirs.
    const linkish=text=>LINKISH.test(text);
    // Words beside a website that ask for a look ("black card", "glossy, vertical") are their design, never their name.
    const designWords=text=>!!text&&(win.PocketDesign?.read?.(text)?.edits?.length||0)>0;

    function setSite(next,quiet){
      const previous=site;if(previous?.url===next.url)return;
      site=next;carrier.value=next.url;siteChip?.remove();
      const main=node('span','pfc-main'),cross=node('span','pfc-x');
      main.innerHTML=LINK;main.append(node('span','pfc-host',next.label),node('span','pfc-path',next.path));asButton(main,fmt(one?kind(next)+': %s, press Delete to remove':T.chip,next.label+next.path),0);
      cross.innerHTML=CROSS;asButton(cross,fmt(T.remove,next.label),-1);
      siteChip=node('span','pfc-chip pfc-chip--url');siteChip.append(main,cross);chipRow.prepend(siteChip);
      if(quiet)return;
      say(one?fmt(T.linkAdded,kind(next))+next.label+next.path+'. '+T.describe+'.':fmt(T.added,next.label+next.path));track('pf_composer_chip_created',one?{tld:next.tld,variant:'one_box'}:{tld:next.tld});
      if(previous)toast(fmt(T.replaced,previous.label),()=>{setSite(previous,true);sync();});
    }
    function dropSite(){site=null;carrier.value='';siteChip?.remove();siteChip=null;}
    // A review site's link says so (the same hosts as the order rule: PocketCore.REVIEW_HOSTS); any other link is a website.
    function kind(s){
      const hosts=win.PocketCore?.REVIEW_HOSTS||{},domain=String(s?.domain||'');
      for(const name in hosts)if(hosts[name].some(h=>domain===h||domain.endsWith('.'+h)))return fmt(T.review,name);
      return T.website;
    }
    function setName(text){
      nameText=text;nameChip?.remove();
      const main=node('span','pfc-main'),cross=node('span','pfc-x');
      main.append(node('span','pfc-host',text));asButton(main,fmt(T.nameChip,text),0);
      cross.innerHTML=CROSS;asButton(cross,fmt(T.remove,text),-1);
      nameChip=node('span','pfc-chip pfc-chip--name');nameChip.append(main,cross);
      if(siteChip)siteChip.after(nameChip);else chipRow.prepend(nameChip);
    }
    function dropName(){nameText='';nameChip?.remove();nameChip=null;}
    // The one box's link chip from what was typed or pasted: words before the link are their business name (80
    // characters or fewer, not a link; longer words are their description), words after it describe their design.
    function place(s,beforeText,afterText){
      const before=clean(beforeText),after=clean(afterText);
      setSite(s);
      let words=after;
      if(before){if(before===promptMark||[...before].length>80||linkish(before)||nameText)words=[before,after].filter(Boolean).join(' ');else setName(before);}
      promptMark='';
      input.value=[...words].slice(0,300).join('');
      if(doc.activeElement===input){const end=input.value.length;input.setSelectionRange(end,end);}
    }
    function adopt(){
      const value=carrier.value.trim();if(!value||value===site?.url)return;
      const brand=win.PocketPersonalization?.store?.getState?.().brand,own=!!brand&&!brand.domain&&clean(value)===clean(String(brand.businessName||''));
      const s=!own&&parseWebsite(value,{window:win,loose:true});
      if(s&&s.domain!==site?.domain)setSite(s,true);else if(!s){input.value=value;if(own)chosen=clean(value);}
      if(one&&s)restore(s);
      carrier.value=site?.url||'';sync();
    }
    // all: paste, blur, Enter. Typing: only the word a space or comma just closed, before the caret (not one being edited).
    function commit(all){
      if(one){
        if(site)return;
        const value=input.value,at=input.selectionStart??value.length,words=/[^\s,]+/g;let match,hit=null;
        while(!hit&&(match=words.exec(value))){
          const end=match.index+match[0].length;if(!all&&end+1!==at)continue;
          const s=match[0]!==chosen&&parseWebsite(match[0],{window:win});if(s)hit={s,start:match.index,end};
        }
        if(hit)place(hit.s,value.slice(0,hit.start),value.slice(hit.end));
        return;
      }
      for(let pass=0;pass<4;pass++){
        const value=input.value,at=input.selectionStart??value.length,words=/[^\s,]+/g;let match,hit=null;
        while(!hit&&(match=words.exec(value))){
          const end=match.index+match[0].length;if(!all&&end+1!==at)continue;
          const s=match[0]!==chosen&&parseWebsite(match[0],{window:win});if(s)hit={s,start:match.index,end:/^[\s,]/.test(value.slice(end))?end+1:end};
        }
        if(!hit)return;
        const joined=value.slice(0,hit.start)+value.slice(hit.end);
        input.value=joined.replace(/^\s+/,'');
        const keep=Math.max(0,(at<=hit.start?at:at>=hit.end?at-(hit.end-hit.start):hit.start)-(joined.length-input.value.length));
        if(doc.activeElement===input)input.setSelectionRange(keep,keep);
        setSite(hit.s);
      }
    }
    function attach(list){
      error='';
      for(const f of Array.from(list||[])){
        const type=TYPES[f.type]?f.type:EXT[(/\.([a-z]+)$/i.exec(f.name||'')||[])[1]?.toLowerCase()];
        if(images.length>=3){fail(T.max);break;}
        if(!type){fail(T.type);continue;}
        if(f.size>50*1024*1024){fail(T.size);continue;}
        const item={file:f,id:++seq,name:(f.name||'image').slice(0,60),src:win.URL.createObjectURL?.(f)||''},main=node('span','pfc-main'),img=node('img');
        img.alt='';img.decoding='async';img.addEventListener('error',()=>{if(['heic','pdf'].includes(TYPES[type])){img.hidden=true;return;}removeImage(item);fail(T.broken);});if(item.src)img.src=item.src;
        asButton(main,'',0);main.append(img);item.chip=node('span','pfc-chip pfc-chip--img');item.chip.append(main);item.chip.pfcItem=item;
        images.push(item);art=art||item;if(one)chipRow.append(item.chip);else field.insertBefore(item.chip,input);
        say(fmt(T.imageAdded,item.name));track('pf_composer_attach',{type:TYPES[type],size_kb:Math.round(f.size/1024)});
      }
      sync();field.scrollLeft=field.scrollWidth;
    }
    function removeImage(item){
      const index=images.indexOf(item);if(index<0)return;
      images.splice(index,1);item.chip.remove();if(item.src)win.URL.revokeObjectURL?.(item.src);
      if(art===item)art=images[0]||null;if(selected===item)selected=null;sync();
    }
    function remove(chip){
      if(picked===chip)picked=null;
      if(chip===siteChip){say(fmt(T.removed,site.label));if(one)promptMark=clean(input.value);dropSite();sync();}
      else if(chip===nameChip){say(fmt(T.removed,nameText));dropName();sync();}
      else if(chip.pfcItem){say(fmt(T.removed,chip.pfcItem.name));removeImage(chip.pfcItem);}
    }
    function activate(chip){
      if(chip===siteChip){
        const text=site.label+site.path;dropSite();
        input.value=text+(input.value?' '+input.value:'');input.focus();input.setSelectionRange(text.length,text.length);
      }else if(chip.pfcItem){selected=selected===chip.pfcItem?null:chip.pfcItem;sync();if(selected&&selected!==art)useButton.focus();}
      else if(chip===nameChip)chip.firstChild.focus();
      sync();
    }
    function sync(){
      const text=clean(input.value),filled=!!(site||images.length);
      for(const item of images){
        item.chip.classList.toggle('is-art',item===art);item.chip.classList.toggle('is-selected',item===selected);
        item.chip.firstChild.setAttribute('aria-label',fmt(item===art?T.art:T.image,item.name));
      }
      input.required=!filled;
      form.classList.toggle('pfc-filled',filled||!!input.value);
      form.classList.toggle('pfh-ph-on',!filled&&!input.value&&doc.activeElement!==input);
      useButton.hidden=!selected||selected===art;removeButton.hidden=!selected;
      const link=!!text&&linkish(text);
      // "Use ‘dr.tattoo’ as my business name" only for text Preview would read as a website: Preview takes any other
      // name as it is. It waits while a website may still be being typed (see hold()).
      nameButton.hidden=!!(selected||error||site||!text||link||named()||held&&SITE_SO_FAR.test(text)||!parseWebsite(text,{window:win,loose:true}));q('[data-pfc-name-text]').textContent=link?'':text;
      hint.textContent='';
      if(selected)hint.textContent=selected===art?T.onCard:'';
      else if(error)hint.textContent=error;
      else if(site&&text&&!link&&!one){const t=designWords(text)?T.design:T.notes;hint.append(t[0],node('span','pfc-q',text),t[1]);}
      else if(one&&site&&[...text].length>250)hint.textContent=fmt(T.left,String(300-[...text].length));
      // An image not on their card yet (beside a website, or dropped or pasted): Preview puts it there. One already sent
      // with this website (the field as "Change" brings it back) needs nothing.
      else if(images.length&&(art!==sentArt||!!site&&site.url!==sentSite))hint.textContent=T.addSite;
      else if(!site&&!text)hint.textContent=T.helper;
      hint.hidden=!hint.firstChild;hint.classList.toggle('is-error',!!error&&!selected);
      if(status?.textContent===T.needSite&&filled)status.textContent='';
      if(one)paintOne();
    }
    // The one box: before a chip it asks for their link (the hero's own words), after it for their design's words.
    // The placeholder is the longest of these that fits on the box's one line (a 360px phone gets the shorter one):
    // screen readers always hear it in full (aria-label).
    function paintOne(){
      input.maxLength=site?300:2048;
      chipRow.hidden=!chipRow.firstChild;form.classList.toggle('pfc-chipped',!!chipRow.firstChild);
      const words=site?[T.describe,T.describeShort].find(fits)||T.describeTiny:carrier.placeholder;
      if(input.placeholder!==words)input.placeholder=words;
      if(site)input.setAttribute('aria-label',T.describe);else input.removeAttribute('aria-label');
      grow();
    }
    let pen=null;
    function fits(text){
      const style=win.getComputedStyle(input),room=input.clientWidth-parseFloat(style.paddingLeft)-parseFloat(style.paddingRight);
      if(!(room>0))return true;
      pen=pen||doc.createElement('canvas').getContext?.('2d');if(!pen)return true;
      pen.font=style.fontStyle+' '+style.fontWeight+' '+style.fontSize+' '+style.fontFamily;
      return pen.measureText(text).width<=room;
    }
    // Up to 3 lines, then it scrolls inside (CSS max-height). Taller than its one line (a chip, or longer words) the
    // box grows (pfc-tall) and the hero makes room under it (--pfc-grow, see sizeHero), so the page moves down.
    function grow(){
      input.style.height='';const height=input.scrollHeight;if(!height)return;
      input.style.height=height+'px';
      const style=win.getComputedStyle(input),max=parseFloat(style.maxHeight);input.classList.toggle('is-full',max>0&&height>max+1);
      form.classList.toggle('pfc-tall',!chipRow.hidden||height>(parseFloat(style.minHeight)||0)+1);
    }
    function lastChip(){return [...chipRow.querySelectorAll('.pfc-chip')].pop()||null;}
    // Backspace at the start of the words: the last chip is picked (said), a second Backspace removes it. The cursor
    // stays in the box, so a phone keyboard stays open (its keydown says 229: beforeinput carries it).
    function backInto(){
      const last=lastChip();if(!last)return;
      if(picked===last){remove(last);return;}
      picked?.classList.remove('is-selected');picked=last;last.classList.add('is-selected');
      say(fmt(T.selected,last===siteChip?site.label:last===nameChip?nameText:last.pfcItem?.name||''));
    }
    function unpick(){if(picked){picked.classList.remove('is-selected');picked=null;}}
    // The words a share text or a typed line puts in: one line (a line break is a space), at the cursor.
    function insert(text){
      const at=input.selectionStart??input.value.length,end=input.selectionEnd??at;
      input.value=input.value.slice(0,at)+text+input.value.slice(end);
      if(site&&[...input.value].length>300)input.value=[...input.value].slice(0,300).join('');
      const caret=Math.min(at+text.length,input.value.length);input.setSelectionRange(caret,caret);
    }
    function toast(text,action){
      undo=action;q('[data-pfc-toast-text]').textContent=text;toastNode.hidden=false;say(text);
      win.clearTimeout(toastTimer);toastTimer=win.setTimeout(hideToast,6000);
    }
    function hideToast(){toastNode.hidden=true;undo=null;}
    // Brand Search hook (later phase; nothing here calls Brandfetch).
    function findBrand(){
      win.clearTimeout(searchTimer);search?.abort();
      const text=clean(input.value);if(typeof api.brandSearch!=='function'||site||text.length<2)return;
      searchTimer=win.setTimeout(()=>{
        search=new win.AbortController();
        const choose=website=>{const s=parseWebsite(website,{window:win,loose:true});if(s){setSite(s);sync();}};
        try{api.brandSearch(text,{signal:search.signal,choose,anchor:form});}catch(_){}
      },250);
    }

    // The one box per tab (sessionStorage pf.onebox.v1): the link sent, its description and the name it came with, so a
    // reload and question 1's "Change" show them again. Another design starts empty.
    const MEMORY='pf.onebox.v1';
    function remember(detail){try{win.sessionStorage?.setItem(MEMORY,JSON.stringify({url:detail.url,prompt:detail.prompt,name:detail.notes}));}catch(_){}}
    function recalled(){try{const m=JSON.parse(win.sessionStorage?.getItem(MEMORY)||'null');return m&&typeof m.url==='string'?m:null;}catch(_){return null;}}
    function restore(s){
      const m=recalled();if(!m||m.url!==s.url)return;
      if(!clean(input.value)&&typeof m.prompt==='string')input.value=[...clean(m.prompt)].slice(0,300).join('');
      if(!nameText&&typeof m.name==='string'&&clean(m.name))setName([...clean(m.name)].slice(0,80).join(''));
    }
    if(one)doc.addEventListener('pocket:design-reset',()=>{try{win.sessionStorage?.removeItem(MEMORY);}catch(_){}dropName();promptMark='';sync();});

    // Typed key by key (not pasted or dropped): the name row waits until a second passes without a key, so a
    // website on its way ("getpocketfac…") is never offered as their business name.
    function hold(){held=true;win.clearTimeout(holdTimer);holdTimer=win.setTimeout(()=>{held=false;sync();},1000);}
    input.addEventListener('input',event=>{
      if(event.isComposing)return;
      if(one){
        unpick();
        if(/[\r\n]/.test(input.value)){const at=input.selectionStart;input.value=input.value.replace(/\r?\n/g,' ');input.setSelectionRange(at,at);}
        if(site&&[...input.value].length>300)input.value=[...input.value].slice(0,300).join('');
      }
      const whole=pasting||/^insertFrom(Paste|Drop)$/.test(event.inputType||'');
      error='';if(whole)held=false;else hold();commit(whole);pasting=false;sync();findBrand();
    });
    input.addEventListener('compositionend',()=>{commit(false);sync();});
    if(one)input.addEventListener('beforeinput',event=>{
      if(event.isComposing)return;
      const type=event.inputType||'';
      if(type==='insertLineBreak'||type==='insertParagraph'){event.preventDefault();preview();}
      else if(type==='deleteContentBackward'&&input.selectionStart===0&&input.selectionEnd===0&&lastChip()){event.preventDefault();backInto();}
    });
    // Preview from the box (Enter, a phone's Go): the link chips first, as on the button.
    function preview(){commit(true);sync();if(form.requestSubmit)form.requestSubmit(submit);else submit.click();}
    input.addEventListener('keydown',event=>{
      if(event.isComposing||event.keyCode===229)return;
      if(one){
        const start=input.selectionStart===0&&input.selectionEnd===0;
        if(event.key==='Enter'){event.preventDefault();preview();return;}
        if(event.key==='Backspace'&&start&&lastChip()){event.preventDefault();backInto();return;}
        if((event.key==='ArrowUp'||event.key==='ArrowLeft')&&start&&lastChip()){event.preventDefault();unpick();lastChip().firstChild.focus();return;}
        if(event.key!=='Backspace')unpick();
        return;
      }
      if(event.key==='Enter'){commit(true);sync();return;}
      const mains=field.querySelectorAll('.pfc-main');
      if(mains.length&&((event.key==='Backspace'&&!input.value)||(event.key==='ArrowLeft'&&!input.selectionStart&&!input.selectionEnd))){event.preventDefault();mains[mains.length-1].focus();}
    });
    input.addEventListener('focus',()=>{selected=null;sync();field.scrollLeft=field.scrollWidth;});
    input.addEventListener('blur',()=>{unpick();commit(true);sync();win.setTimeout(()=>{if(!form.contains(doc.activeElement))field.scrollLeft=0;},400);});
    field.addEventListener('scroll',()=>field.classList.toggle('is-scrolled',field.scrollLeft>2),{passive:true});
    field.addEventListener('mousedown',event=>{if(event.target.closest('.pfc-x'))event.preventDefault();});
    field.addEventListener('click',event=>{
      const cross=event.target.closest('.pfc-x'),main=event.target.closest('.pfc-main');
      if(cross){remove(cross.parentNode);input.focus();}else if(main)activate(main.parentNode);else input.focus();
    });
    field.addEventListener('keydown',event=>{
      const main=event.target,key=event.key;if(!main.classList.contains('pfc-main'))return;
      const mains=[...field.querySelectorAll('.pfc-main')],index=mains.indexOf(main);
      if(key==='Delete'||key==='Backspace'){event.preventDefault();remove(main.parentNode);input.focus();}
      else if(key==='Enter'||key===' '){event.preventDefault();activate(main.parentNode);}
      else if(key==='ArrowLeft'){event.preventDefault();(mains[index-1]||main).focus();}
      else if(key==='ArrowRight'||key==='Escape'){event.preventDefault();((key==='ArrowRight'&&mains[index+1])||input).focus();}
      else if(key.length===1&&!event.ctrlKey&&!event.metaKey&&!event.altKey)input.focus();
    });
    entry.addEventListener('focusout',event=>{if(selected&&!entry.contains(event.relatedTarget)){selected=null;sync();}});
    const dragging=event=>Array.from(event.dataTransfer?.types||[]).includes('Files');
    for(const type of ['dragenter','dragover'])entry.addEventListener(type,event=>{if(dragging(event)){event.preventDefault();form.classList.add('pfc-drop');}});
    entry.addEventListener('dragleave',event=>{if(!entry.contains(event.relatedTarget))form.classList.remove('pfc-drop');});
    entry.addEventListener('drop',event=>{if(dragging(event)){event.preventDefault();form.classList.remove('pfc-drop');attach(event.dataTransfer.files);}});
    entry.addEventListener('paste',event=>{
      const files=Array.from(event.clipboardData?.files||[]),text=event.clipboardData?.getData('text/plain')||'';
      const pasted=event.target===input&&!/[\s,]/.test(text.trim())&&text.trim()!==chosen&&parseWebsite(text,{window:win});
      if(one&&event.target===input&&!files.length&&pasteOne(text)){event.preventDefault();error='';sync();return;}
      if(files.length){event.preventDefault();attach(files);}
      else if(pasted){event.preventDefault();error='';setSite(pasted);sync();}
      else if(event.target===input)pasting=true;
    });
    // A paste in the one box: after a chip, words (one line, at the cursor); before one, the first link anywhere in it
    // chips at once. Lines above the link are a share text's business, its first line their name (the address under it
    // is dropped); words after the link describe their design. true when handled here.
    function pasteOne(raw){
      const text=String(raw||'');if(!text.trim())return false;
      if(site){insert(clean(text));return true;}
      const at=input.selectionStart??input.value.length,end=input.selectionEnd??at,typed=input.value;
      const lines=[typed.slice(0,at),...text.split(/\r?\n/),typed.slice(end)].map(clean).filter(Boolean);
      let hit=null;
      for(let i=0;i<lines.length&&!hit;i++)for(const m of lines[i].matchAll(/[^\s,]+/g)){const s=m[0]!==chosen&&parseWebsite(m[0],{window:win});if(s){hit={s,i,start:m.index,end:m.index+m[0].length};break;}}
      if(!hit)return false;
      const line=lines[hit.i],above=lines.slice(0,hit.i),same=clean(line.slice(0,hit.start));
      const before=above.length?above[0]:same,after=[line.slice(hit.end),...lines.slice(hit.i+1)].map(clean).filter(Boolean).join(' ');
      // Several lines above a link (a business, its address): the first is the name; one line is read as typed.
      place(hit.s,above.length&&[...before].length<=80?before:[...above,same].filter(Boolean).join(' '),after);
      return true;
    }
    q('[data-pfc-clip]').addEventListener('click',()=>file.click());
    // "Upload your logo" with nothing typed, or beside their name: the logo they chose goes on their card now (with that
    // name). Beside a website, or text that is (or may still become) one, Preview sends them together.
    file.addEventListener('change',()=>{
      const text=clean(input.value),alone=!site&&!(text&&(linkish(text)||held&&SITE_SO_FAR.test(text))),before=images.length;
      attach(file.files);file.value='';
      if(!alone||images.length<=before)return;
      art=images[before];sync();
      if(form.requestSubmit)form.requestSubmit(submit);else submit.click();
    });
    useButton.addEventListener('click',()=>{const item=selected;if(!item)return;art=item;selected=null;sync();say(fmt(T.nowOnCard,item.name));item.chip.firstChild.focus();});
    removeButton.addEventListener('click',()=>{if(selected){say(fmt(T.removed,selected.name));removeImage(selected);}input.focus();});
    // Keep focus in the field: a blur would chip "dr.tattoo" under the tap. Preview too, pressed while they type: the
    // blur's chip (and the name row it hides) would move Preview from under the press (the submit makes the chip itself).
    for(const type of ['pointerdown','mousedown'])nameButton.addEventListener(type,event=>event.preventDefault());
    for(const type of ['pointerdown','mousedown'])submit.addEventListener(type,event=>{if(doc.activeElement===input)event.preventDefault();});
    nameButton.addEventListener('click',()=>{asName=true;chosen=clean(input.value);if(form.requestSubmit)form.requestSubmit(submit);else submit.click();asName=false;});
    q('[data-pfc-undo]').addEventListener('click',()=>{const action=undo;hideToast();action?.();input.focus();});
    // Enter in "Anything specific?" sends the card, as Enter in the field above it does (with nothing above, the cursor
    // goes there: a website, a name or a logo makes the card, their words shape it).
    ideaBox?.addEventListener('keydown',event=>{
      if(event.key!=='Enter'||event.isComposing||event.keyCode===229)return;
      event.preventDefault();commit(true);sync();
      if(!site&&!images.length&&!clean(input.value)){input.focus();return;}
      if(form.requestSubmit)form.requestSubmit(submit);else submit.click();
    });

    doc.addEventListener('submit',event=>{
      if(event.target!==form)return;
      if(!asName)commit(true);
      if(one){submitOne(event);return;}
      // Their chosen name is never read as a website; beside a website chip it is the name printed with it.
      const name=named(),text=clean(input.value),stop=()=>{event.preventDefault();event.stopImmediatePropagation();};
      let target=asName?null:site,loose=false;
      if(!target&&!name&&text&&!/\s/.test(text))loose=!!(target=parseWebsite(text,{window:win,loose:true}));
      // Link-like text left over (not a website we can use) is never sent as their name: ask them to check it.
      if(text&&!loose&&linkish(text)){stop();fail(T.badLink);input.focus();return;}
      // Their words for the design: the "Anything specific?" box, and words beside a website that ask for a look.
      const beside=target&&!loose&&designWords(text)?text:'',idea=[clean(ideaBox?.value||''),beside].filter(Boolean).join(', ');
      const detail={url:target?.url||'',domain:target?.domain||'',name:target?'':text,notes:target&&!loose&&!beside?text:'',idea,images:images.map(item=>item.file),artworkIndex:images.indexOf(art)};
      if(!detail.url&&!detail.name&&!detail.images.length){stop();input.focus();return;}
      const key=JSON.stringify([detail.url,detail.name,detail.notes,detail.idea,detail.artworkIndex,images.map(item=>item.id)]);
      if(key===lastKey&&(detail.url?form.getAttribute('aria-busy')==='true':Date.now()-lastAt<2000)){stop();return;}
      lastKey=key;lastAt=Date.now();carrier.value=detail.url;
      const taken=!doc.dispatchEvent(new win.CustomEvent('pocket:composer-submit',{detail,cancelable:true}));
      // The 2 s run from when the card has it: a slow phone drawing the card does not shorten them (the same logo, sent
      // again under them, was uploaded twice).
      lastAt=Date.now();
      track('pf_composer_submit',{has_url:!!detail.url,has_image:!!detail.images.length,has_name:!!detail.name,has_notes:!!detail.notes,has_idea:!!detail.idea});
      input.blur();
      if(detail.url||taken){sentArt=art;sentSite=site?.url||'';sync();}
      if(detail.url&&!taken)return;
      stop();if(!taken&&status)status.textContent=T.needSite;
    },true);

    // The one box's Preview (its words go to pocket-design.js as the event's idea, as the old "Anything specific?" box's did): with a link chip, the words are their design's description (prompt), never a name or a note
    // (the name it came with is the note: printed beside it). Without one, the words are their business name, never a
    // design: over 80 characters they need the link first, and stay to become its description.
    function submitOne(event){
      const text=clean(input.value),stop=()=>{event.preventDefault();event.stopImmediatePropagation();};
      let detail;
      if(site){
        const prompt=[...text].slice(0,300).join('');
        if(prompt&&[...prompt].length<3){stop();fail(T.promptShort);input.focus();return;}
        detail={url:site.url,domain:site.domain,name:'',notes:nameText,prompt,idea:prompt,images:images.map(item=>item.file),artworkIndex:images.indexOf(art)};
      }else{
        const name=named();let target=null;
        if(!asName&&!name&&text&&!/\s/.test(text))target=parseWebsite(text,{window:win,loose:true});
        if(!target&&text&&linkish(text)&&!name){stop();fail(T.badLink);input.focus();return;}
        if(!target&&[...text].length>80){stop();fail(T.linkFirst);input.focus();return;}
        detail={url:target?.url||'',domain:target?.domain||'',name:target?'':text,notes:'',prompt:'',idea:'',images:images.map(item=>item.file),artworkIndex:images.indexOf(art)};
      }
      if(!detail.url&&!detail.name&&!detail.images.length){stop();input.focus();return;}
      const key=JSON.stringify([detail.url,detail.name,detail.notes,detail.prompt,detail.artworkIndex,images.map(item=>item.id)]);
      if(key===lastKey&&(detail.url?form.getAttribute('aria-busy')==='true':Date.now()-lastAt<2000)){stop();return;}
      lastKey=key;lastAt=Date.now();carrier.value=detail.url;
      if(detail.url)remember(detail);
      const taken=!doc.dispatchEvent(new win.CustomEvent('pocket:composer-submit',{detail,cancelable:true}));
      track('pf_composer_submit',{has_url:!!detail.url,has_image:!!detail.images.length,has_name:!!detail.name,has_notes:!!detail.notes,has_prompt:!!detail.prompt,variant:'one_box'});
      input.blur();
      if(detail.url||taken){sentArt=art;sentSite=site?.url||'';sync();}
      if(detail.url&&!taken)return;
      stop();if(!taken&&status)status.textContent=T.needSite;
    }

    // "Preview my cards" further down, before any preview: what is already in this field is used, never asked again.
    // An empty field is where they land (it takes a website, a name or their logo), never a website-only dialog.
    win.addEventListener('click',event=>{
      if(!event.target.closest?.('[data-buy-bar] [data-purchase],[data-pfx-buy]')||win.PocketPersonalization?.store?.getState?.().brand)return;
      commit(true);sync();
      event.preventDefault();event.stopImmediatePropagation();
      form.scrollIntoView?.({block:'center',behavior:win.matchMedia?.('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
      if(!site&&!images.length&&!clean(input.value)){input.focus({preventScroll:true});return;}
      if(form.requestSubmit)form.requestSubmit(submit);else submit.click();
    },true);

    // The cursor already in #ReviewsWebsite (?focus=website from the docs and guides, or a shopper quicker than this
    // script) moves to the visible field, with anything typed so far.
    if(typed){input.value=typed;if(typing){input.focus();input.setSelectionRange(caret,caret);}else commit(true);}else if(typing)input.focus({preventScroll:true});
    if(one&&!typed&&!site){const m=recalled(),s=m&&parseWebsite(m.url,{window:win,loose:true});if(s){setSite(s,true);carrier.value=s.url;restore(s);}}
    if(one){
      win.addEventListener('resize',()=>paintOne(),{passive:true});
      // The hero is a full screen: it adds the box's growth under itself (pocket-composer.css), and nothing when the
      // box is hidden.
      const hero=form.closest('[data-pfh]');
      const sizeHero=()=>{const rest=parseFloat(win.getComputedStyle(form).minHeight)||0,grown=form.offsetParent&&form.classList.contains('pfc-tall')?Math.max(0,Math.round(form.getBoundingClientRect().height-rest)):0;hero.style.setProperty('--pfc-grow',grown+'px');};
      if(hero&&win.ResizeObserver)new win.ResizeObserver(sizeHero).observe(form);
    }
    sync();host.dataset.pfcReady='true';
    return {input,field,attach};
  }

  const api={init,parseWebsite,brandSearch:null};
  return api;
});
